// Gates Google Maps behind CookieYes consent so maps.googleapis.com is never
// requested until the visitor has accepted the relevant cookie category.
var MAPS_CONSENT_CATEGORY = 'functional'; // must match the category assigned to Google Maps in the CookieYes dashboard

function parseCookieYesConsent() {
	var match = document.cookie.match(/(?:^|;\s*)cookieyes-consent=([^;]*)/);
	if (!match) return null;
	var raw = decodeURIComponent(match[1]);
	return raw.split(',').reduce(function (acc, pair) {
		var parts = pair.split(':');
		if (parts[0]) acc[parts[0]] = parts[1];
		return acc;
	}, {});
}

function hasMapsConsent() {
	var consent = parseCookieYesConsent();
	return !!consent && consent[MAPS_CONSENT_CATEGORY] === 'yes';
}

var mapsScriptPromise = null;
function loadGoogleMapsScript(src) {
	if (!mapsScriptPromise) {
		mapsScriptPromise = new Promise(function (resolve, reject) {
			if (window.google && window.google.maps) {
				resolve();
				return;
			}
			var script = document.createElement('script');
			script.src = src;
			script.async = true;
			script.onload = function () {
				resolve();
			};
			script.onerror = reject;
			document.head.appendChild(script);
		});
	}
	return mapsScriptPromise;
}

function showMap(placeholderEl, mapEl) {
	if (placeholderEl) {
		placeholderEl.classList.remove('show');
		placeholderEl.classList.add('hide');
	}
	if (mapEl) {
		mapEl.classList.remove('hide');
		mapEl.classList.add('show');
	}
}

function whenMapsConsentGranted(handler) {
	if (hasMapsConsent()) {
		handler();
		return;
	}
	document.addEventListener('cookieyes_consent_update', function (eventData) {
		var accepted = (eventData.detail && eventData.detail.accepted) || [];
		if (accepted.indexOf(MAPS_CONSENT_CATEGORY) !== -1) {
			handler();
		}
	});
}

module.exports = {
	loadGoogleMapsScript: loadGoogleMapsScript,
	showMap: showMap,
	whenMapsConsentGranted: whenMapsConsentGranted,
};
